import React from "react";
import styled from "styled-components";
import { object, func, string } from "prop-types";
import { useTranslation } from "@lib/i18n";

import Typography from "../shared/Typography";
import Heading from "../shared/Heading";
import Subheading from "../shared/Subheading";

import gtm from "@gtm/core";
import { useScrollToView } from "@hooks/useScrollToView";
import { testDriveLinkEvent } from "@gtm/events/testdrive";

import {
  desktop,
  prop,
  color,
  fontSize,
  fontWeight,
  font,
} from "../shared/utils";

const TitleWrapper = styled.div`
  margin-bottom: 4rem;

  ${desktop`
    margin-bottom: 0;
  `}
`;

const MainTitle = styled(Heading)`
  font-size: ${fontSize("xl")};
  font-family: ${font("citroen")};
  font-weight: ${fontWeight("bolder")};
  text-transform: uppercase;
  margin-bottom: 1rem;

  ${desktop`
    font-size: ${fontSize("xxxl")};
  `}
`;

const Description = styled(Subheading)`
  color: ${color("black")};
  font-size: ${fontSize("sm")};
  width: 75%;
  margin: 0 auto;

  ${desktop`
    width: 100%;
  `}
`;

const SubTitle = styled(Typography)`
  color: ${prop("color")};
  text-transform: uppercase;
  font-family: ${font("citroen")};
  font-size: ${fontSize("md")};
  font-weight: ${fontWeight("bolder")};
  margin: 1rem 0;

  ${desktop`
    font-size: ${fontSize("lg")};
  `}
`;

const ScrollToTypes = styled.span`
  cursor: pointer;
  white-space: nowrap;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

const TitleContainer = ({
  typesContainerRef,
  setIsTypeExplanationOpen,
  textColor,
}) => {
  const { t } = useTranslation();
  const scrollToView = useScrollToView();

  const scrollToTypeExplanation = () => {
    scrollToView(typesContainerRef);
    setIsTypeExplanationOpen(true);
    gtm.fire(testDriveLinkEvent());
  };

  return (
    <TitleWrapper>
      <MainTitle customColor={textColor}>{t("testDrive.title")}</MainTitle>
      <Description>
        {t("testDrive.description")}{" "}
        <ScrollToTypes onClick={scrollToTypeExplanation}>
          {t("testDrive.typesLink")}
        </ScrollToTypes>
      </Description>
      <SubTitle color={textColor}>{t("testDrive.subtitle")}</SubTitle>
    </TitleWrapper>
  );
};

TitleContainer.propTypes = {
  typesContainerRef: object,
  setIsTypeExplanationOpen: func.isRequired,
  textColor: string.isRequired,
};

export default TitleContainer;
